import { html } from 'lit';
interface LandingAction { label: string; href: string }
import type { WebEditorElementDefinition as LandingEditorElementDefinition } from '../../element-definition.js';

interface FooterLinksOptions {
  links: LandingAction[];
  add: () => void;
  definitions: LandingEditorElementDefinition[];
  updateField: (definition: LandingEditorElementDefinition, value: string) => void;
  move: (definition: LandingEditorElementDefinition, direction: -1 | 1) => void;
  duplicate: (definition: LandingEditorElementDefinition) => void;
  remove: (definition: LandingEditorElementDefinition) => void;
}

export const renderEditorFooterLinks = ({ links, definitions, updateField, move, duplicate, remove, add }: FooterLinksOptions) => {
  const definition = (index: number, field = '') => definitions.find(item => item.id === `footer.link.${index}${field}`);
  return html`
    <section class="vp-editor-panel-section vp-editor-footer-links">
      <p class="vp-editor-kicker">Footer-Links</p>
      <p class="vp-editor-muted">Text und Ziel hier bearbeiten. Die Pfeile ändern die Reihenfolge im Grid für alle Sprachen.</p>
      ${links.map((link, index) => {
        const container = definition(index);
        return html`<div class="vp-editor-footer-link-row">
          <label>Link ${index + 1}
            <input type="text" .value=${link.label} aria-label=${`Footer-Link ${index + 1}: Text`}
              @change=${(event: Event) => {
                const field = definition(index, '.label');
                if (field) updateField(field, (event.target as HTMLInputElement).value);
              }} />
          </label>
          <label>Ziel
            <input type="text" .value=${link.href} placeholder="/kontakt oder https://…" aria-label=${`Footer-Link ${index + 1}: Ziel`}
              @change=${(event: Event) => {
                const field = definition(index, '.href');
                if (field) updateField(field, (event.target as HTMLInputElement).value);
              }} />
          </label>
          <div class="vp-editor-footer-link-actions">
            <button type="button" class="vp-editor-icon-button" title="Früher anzeigen" aria-label=${`${link.label}: früher anzeigen`}
              ?disabled=${!container || index === 0} @click=${() => container && move(container, -1)}>
              <span class="icon-[material-symbols--arrow-upward]" aria-hidden="true"></span>
            </button>
            <button type="button" class="vp-editor-icon-button" title="Später anzeigen" aria-label=${`${link.label}: später anzeigen`}
              ?disabled=${!container || index === links.length - 1} @click=${() => container && move(container, 1)}>
              <span class="icon-[material-symbols--arrow-downward]" aria-hidden="true"></span>
            </button>
            <button type="button" class="vp-editor-icon-button" title="Link duplizieren" aria-label=${`${link.label}: duplizieren`}
              ?disabled=${!container} @click=${() => container && duplicate(container)}>
              <span class="icon-[material-symbols--content-copy]" aria-hidden="true"></span>
            </button>
            <button type="button" class="vp-editor-icon-button" title="Link entfernen" aria-label=${`${link.label}: entfernen`}
              ?disabled=${!container} @click=${() => container && remove(container)}>
              <span class="icon-[material-symbols--delete-outline]" aria-hidden="true"></span>
            </button>
          </div>
        </div>`;
      })}
      <button type="button" class="vp-editor-button" @click=${add}>Link hinzufügen</button>
    </section>`;
};
